
<template>
  <div class="out">
    <div class="outContent">
      <Home v-if="active == 0"></Home>
      <Classify v-if="active == 1"></Classify>
      <Study v-if="active == 2"></Study>
      <Mine v-if="active == 3"></Mine>
    </div>
    <van-tabbar
      v-model="active"
      active-color="#4E7DF7"
      inactive-color="#CACDE0"
      placeholder
      z-index="999"
      @change="onChange"
    >
      <van-tabbar-item>
        <span>首页</span>
        <template #icon="props">
          <img v-if="props.active" src="./../../assets/school/home2.png" class="btm-icon" />
          <img v-else src="./../../assets/school/home1.png" class="btm-icon" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>分类</span>
        <template #icon="props">
          <img v-if="props.active" src="./../../assets/school/classify2.png" class="btm-icon" />
          <img v-else src="./../../assets/school/classify1.png" class="btm-icon" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>学习</span>
        <template #icon="props">
          <img v-if="props.active" src="./../../assets/school/checked4.png" class="btm-icon" />
          <img v-else src="./../../assets/school/unselected5.png" class="btm-icon" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <img v-if="props.active" src="./../../assets/school/mine2.png" class="btm-icon" />
          <img v-else src="./../../assets/school/mine1.png" class="btm-icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Home from "./home.vue";
import Classify from "./classify.vue";
import Study from "./study.vue";
import Mine from "./mine.vue";
export default {
  data() {
    return {
      active: 0,
    };
  },
  components: { Home, Classify, Study, Mine },
  mounted() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
    }
    if (sessionStorage.getItem("active")) {
      this.active = Number(sessionStorage.getItem("active"));
    }
  },
  methods: {
    onChange() {
      sessionStorage.setItem("active", this.active);
    },
  },
};
</script>

<style scoped>
.out {
  height: 100%;
  background-color: #f5f5f5;
}
.outContent {
  height: 100%;
  height: calc(100% - 50px);
}
.btm-icon{
  width: 24px;
  height: 24px;
}
</style>